import api from '@/modules/axios'
import apiHelperParams from '@/modules/apiHelperParams'

import store from '@/store/store'
import globalConfig from '@/config'
import apiHelperParamsJson from '@/modules/apiHelperParamsJson'

let obj = {
    url: process.env.VUE_APP_URL_MAIM,
    data: { h: 1 },
    params: { h: 2 },
    h: 'qweq',
    headers: {
        withCredentials: true,
        kakos: true
    },
    withCredentials: true
}

export default {
    init(params) {
        if (params.uuid == null) params.uuid = store.state.api.uuid
        //params.uuid = 'a7935c69-9304-535c-824a-d2673f327468'
        params.current_url = globalConfig.localhostPage || window.location.href
        //params.uuid = null
        return api.post(
            '/widget/init',
            { ...apiHelperParamsJson(params, 'post').data },
            { headers: apiHelperParamsJson(params, 'post').headers }
        )
    },
    socketPolling(params) {
        if (globalConfig.polling_server) {
            return api({
                baseURL: globalConfig.polling_server,
                method: 'get',
                url: '/socket/polling',
                params: apiHelperParamsJson(params).params,
                headers: apiHelperParamsJson(params).headers
            })
        }
    },
    /*    init(params) {
        //params.uuid = null
        return api.post(process.env.VUE_APP_URL_MAIM, {

            firstName: 'Fred'


        },{
            headers:{

            },
            withCredentials: true,
        })
    },*/
    init_() {
        let data = {
            json:
                '{"event":"init","params":{"uuid":null,"current_url":"https://effect.reg.ru/","browsed_pages_count":1,"guest_referrer":"","title":"Effect - феноменальный подход к общению с клиентами на сайте","is_mobile":0,"session_start":1,"lang":"ru-RU","uuids":{}}}'
        }
        //let params = {"uuid":'123',"current_url":"https://effect.reg.ru/","browsed_pages_count":1,"guest_referrer":"","title":"Effect - феноменальный подход к общению с клиентами на сайте","is_mobile":0,"session_start":1,"lang":"ru-RU","uuids":{}}
        return api.post(process.env.VUE_APP_URL_MAIM, data)
    }
}
